/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
import { connect } from 'react-redux';
import { currentModelId } from '#selectors/entities/models.js';
import { getExtractionDocument } from '#actions/models/extractionJob.js';
import ProvenancePopover from './ProvenancePopover.jsx';

const mapStateToProps = state => ({ modelId: currentModelId(state) });

const mapDispatchToProps = { getExtractionDocument };

// Keys the "view the cited page" fetch off the field's own provenance.documentS3Key
// (UI design §3.3) -- not the model's current job -- so it resolves on a copied model too.
const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { modelId } = stateProps;
  const { provenance } = ownProps;
  return {
    ...ownProps,
    onViewCitedPage: provenance
      ? () => dispatchProps.getExtractionDocument(modelId, provenance.documentS3Key)
      : null,
  };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(ProvenancePopover);
